import { ChangeEventHandler } from 'react';

const RadionButton = (props: {
  selectedRowIndex: boolean;
  handleRadioButtonChange: ChangeEventHandler<HTMLInputElement>;
  name: string;
}) => {
  return (
    <div>
      <label className="flex items-center cursor-pointer">
        <input
          type="radio"
          name="rangeType"
          value="products"
          checked={props.selectedRowIndex}
          onChange={props.handleRadioButtonChange}
          className="hidden"
        />

        <span
          className={`w-5 h-5 rounded-full border-2 mr-2 flex items-center justify-center ${
            props.selectedRowIndex
              ? 'border-primary-blue-500'
              : 'border-gray-400'
          }`}
        >
          {props.selectedRowIndex && (
            <span className="w-2.5 h-2.5 rounded-full bg-primary-blue-500" />
          )}
        </span>

        <span className="text-primary-blue-500">{props.name}</span>
      </label>
    </div>
  );
};

export default RadionButton;
